import React from 'react';

import {useApi} from '@/api';
import PlanChart from '@/b2c/MyPlan/PlanChart';
import PlanTable from '@/b2c/MyPlan/PlanTable';

const MyPlan = () => {
  const [plans, error] = useApi('/b2c/plans', []);

  if (error) {
    return (
      <div>
        <h1>Fail fetching data</h1>
        <p>{String(error)}</p>
      </div>
    );
  }

  return (
    <>
      <PlanChart plans={plans} />
      <PlanTable plans={plans} />
    </>
  );
};

export default MyPlan;
